export const InitialValuesArchitectBank = {
  name: "",
  iban: "",
  bic: ""
};